import { Box, Center } from '@chakra-ui/react'
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext'
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel'
import { UserSprintSelector } from '@src/components/sco/Account/UserSprintSelector'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { AccountPage } from '@src/layouts/AccountPageLayout'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'
export default AccountPage(function () {
  const accountContext = useAccountContext()
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('account.sprint')
  })

  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([
      {
        title: 'Account',
        href: '/account',
      },

      {
        title: 'Sprint',
        href: '/account/sprint',
      },
    ])
  }, [])

  return (
    <AccountMainPanel>
      <Center minHeight={'80vh'}>
        <Box maxWidth={'960px'} padding={'1em'} width={'full'}>
          <UserSprintSelector />
        </Box>
      </Center>
    </AccountMainPanel>
  )
})
